export default __webpack_public_path__ + "static/esg_environment_box_d-cfe4e392a169102acc39335fc7ba56bd.png";